import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs";
import { ConfigService } from "src/app/core/config.service";
import { IacRepositoriesChartsData, IacRepositoryDetails, IacRepositories} from "./iac-repositories.model";
import {IacRepositoryTypeEnum} from "src/app/shared/enum/iac-repository-type.enum";

@Injectable({
    providedIn: 'root'
})
export class IacRepositoriesService {

    constructor(private httpClient: HttpClient, private configService: ConfigService){

    }

    loadIacGitlabRepositories(){
        return this.httpClient.get<IacRepositories>(`${this.configService.config.apiUrl}/iac/repositories/gitlab`)
        .pipe(
            map((response=>{
                const data = []
                const repositoryEnumKeys = Object.keys(IacRepositoryTypeEnum);
                for(let type in response){
                    const repositories = response[type as keyof IacRepositories]
                    if(repositoryEnumKeys.includes(type)){
                        data.push(...repositories.checked.map((value) => {return {...value, type: type, allBadges: value.checked.concat(value.unchecked).concat(value.ignored)}}))
                        data.push(...repositories.unchecked.map((value) => {return {...value, type: type, allBadges: value.checked.concat(value.unchecked).concat(value.ignored)}}))
                        data.push(...repositories.ignored.map((value) => {return {...value, type: type, allBadges: value.checked.concat(value.unchecked).concat(value.ignored)}}))
                    }
                }
                return data
            }))
        )
    }

    loadIacGitlabRepositoryDetails(repositoryId: string){
        return this.httpClient.get<IacRepositoryDetails>(`${this.configService.config.apiUrl}/iac/repositories/gitlab/details?repository_id=${repositoryId}`)
        .pipe(
            map((response=>{
                // The API returns an empty object when the repository is unknown
                response.allBadges = (response.checked ?? []).concat(response.unchecked ?? []).concat(response.ignored ?? [])
                return response
            }))
        )
    }

    loadIacGitlabRepositoriesMeasures(start_date: string, end_date: string, granularity: string){
        return this.httpClient.get<IacRepositoriesChartsData>(`${this.configService.config.apiUrl}/iac/repositories/gitlab/measures?start_date=${start_date}&end_date=${end_date}&granularity=${granularity}`)
    }
}
